import React, { useEffect, useState } from "react";
import axios from "axios";
import { NaguaraLogo } from "@/components/BrandMark";
import Seo from "@/components/Seo";
import { useLang } from "@/i18n";
import { SITE_URL } from "@/lib/config";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Permanent printed URL: naguaracafes.com/qr
 * The destination is decided by the backend (QR_TARGET_URL), so the code on the
 * bags, cups and merch never has to change.
 */
const QrRedirect = () => {
  const { lang, t } = useLang();
  const [target, setTarget] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/qr`)
      .then((r) => {
        if (!cancelled) setTarget(r.data?.target || SITE_URL);
      })
      .catch(() => {
        if (!cancelled) setTarget(SITE_URL);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!target) return undefined;
    // same-origin destinations stay inside the app, so the SPA does not reload
    const here = window.location.origin;
    const url = target.startsWith(here) ? target.slice(here.length) || "/" : target;
    // short pause so the brand screen is always seen instead of a blank flash
    const jump = setTimeout(() => {
      if (url.startsWith("/")) {
        window.history.replaceState(null, "", url);
        window.location.reload();
      } else {
        window.location.replace(url);
      }
    }, 600);
    return () => clearTimeout(jump);
  }, [target]);

  return (
    <div
      data-testid="qr-redirect"
      className="min-h-screen bg-[#422D28] flex flex-col items-center justify-center gap-7 px-6 text-center"
    >
      <Seo
        title={t.qr.title}
        description={t.qr.text}
        path="/qr"
        lang={lang}
        noindex
      />
      <NaguaraLogo variant="beige" width={260} className="w-[200px] sm:w-[260px]" />
      <p className="text-[#E6D9B6]/70 text-base">{t.qr.text}</p>
      <a
        href={target || SITE_URL}
        data-testid="qr-manual-link"
        className="min-h-[48px] inline-flex items-center text-[#F4D35E] font-semibold underline underline-offset-4"
      >
        {t.qr.cta}
      </a>
    </div>
  );
};

export default QrRedirect;
